var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"aria-label":"Toggle Accessibility Options","id":"accessibility-toggle","title":"Toggle Accessibility Options"},on:{"click":_vm.toggleAccessibility}},[_c('i',{ref:"eye",staticClass:"custom-eye open"})])}
var staticRenderFns = []

export { render, staticRenderFns }